import { render } from "./HeroiconsOutlineQuestionMarkCircle.vue?vue&type=template&id=32dd8384"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineQuestionMarkCircle.vue"]])

export default __exports__